<div class="col-lg-12 row" *ngIf="selectedSection === 'Banners'">
    <div class="col-lg-12 ml-2 data-sect">
        <div class="col-lg-12">
            <h3> IAP Banner List</h3>
        </div>
        <hr>
        <table class="table" [svData]="data" #sv="svDataTable" [svRowsOnPage]="pageSize"
            *ngIf="data && data.length > 0">
            <thead>
                <tr>
                    <th class="text-center">Web Image </th>
                    <th class="text-center">Mobile Image </th>
                    <th class="text-center">URL</th>
                    <th class="text-center">Edit</th>
                    <!-- <th class="text-center" width="10%">View</th> -->
                    <th class="text-center">Delete</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of sv.data">

                    <td class="text-center hover-container w-20" (click)="viewFile(item.webBannerImagePath)">
                        {{ item.fileName !== null ? item.fileName : 'NA' }}
                        <img src="assets/icons/view.png" class="view-icon" alt="View Image">
                    </td>
                     
                    <td class="text-center text-truncate hover-container" style="max-width: 250px;" (click)="viewFile(item.mobileBannerImagePath)">
                        {{ item.mobileBannerImagePath !== null ? item.mobileBannerImagePath : 'NA' }}
                        <img src="assets/icons/view.png" class="view-icon" alt="View Image">
                    </td>

                    <td (click)="viewFile(item.clickableUrl)"
                        class="text-center text-truncate hover-container" style="max-width: 250px;">
                       
                        {{ item.clickableUrl !== null ? item.clickableUrl : 'NA' }}
                        <img src="assets/icons/view.png" class="view-icon" alt="View Image">
                    </td>




                    <td class="text-center w-15">
                        <img src="assets/images/Edit.png" class="cursor-pointer" (click)="editFile(item)">
                    </td>

                    <td class="text-center w-15">
                        <img src="assets/icons/delete_icon.png" class="cursor-pointer" (click)="deleteFile(item)">
                    </td>
                </tr>
            </tbody>
            <tfoot *ngIf="data?.length > pageSize">
                <tr>
                    <td colspan="5" class="center-paginator">
                        <sv-bootstrap-paginator></sv-bootstrap-paginator>
                    </td>
                </tr>
            </tfoot>
        </table>

        <div *ngIf="data?.length <= 0">No Banners found</div>
    </div>

</div>
<div class="col-lg-12 row" *ngIf="selectedSection === 'Videos'">
    <div class="col-lg-12 ml-2 data-sect">

        <h3>IAP Video List</h3>

        <table class="table" [svData]="data" #sv="svDataTable" [svRowsOnPage]="pageSize"
            *ngIf="data && data.length > 0">
            <thead>
                <tr>
                    <th class="text-center">Title</th>
                    <th class="text-center">Thumbnail FileName</th>
                    <th class="text-center"> YouTube URL</th>
                    <th class="text-center">Edit</th>
                    <!-- <th class="text-center" width="10%"> View </th> -->
                    <th class="text-center">Delete</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of sv.data">
                    <td [display]="item.title" [tooltip]="item.title" class="text-center" placement="top"
                        show-delay="300" class="text-center">
                        {{ item.title }}
                    </td>
                      <td placement="top" show-delay="300" class="text-center text-truncate hover-container" style="max-width: 250px;"
                        (click)="viewFile(item.imagePath)">
                        {{ item.imageName
                        }}
                        <img src="assets/icons/view.png" class="view-icon" alt="View Image"
                             *ngIf="item.imagePath">
                    </td>
                    <td class="text-center text-truncate hover-container" style="max-width: 250px;" placement="top" show-delay="300"
                        (click)="viewFile(item.youtubeLink)">
                        {{ item.youtubeLink !== null ? item.youtubeLink : 'NA' }}
                        <img src="assets/icons/view.png" class="view-icon" alt="View Image">
                    </td>
                    <td class="text-center">
                        <img src="assets/images/Edit.png" class="cursor-pointer" (click)="editFile(item)">
                    </td>

                    <td class="text-center">
                        <img src="assets/icons/delete_icon.png" class="cursor-pointer" (click)="deleteFile(item)">
                    </td>
                </tr>
            </tbody>
            <tfoot *ngIf="data?.length > pageSize">
                <tr>
                    <td colspan="5" class="center-paginator">
                        <sv-bootstrap-paginator></sv-bootstrap-paginator>
                    </td>
                </tr>
            </tfoot>
        </table>

        <div *ngIf="data?.length <= 0">
            <p class="no-data">No data found</p>
        </div>

    </div>
</div>
<div class="col-lg-12 row"   *ngIf="selectedSection === 'Articles'">
    <mat-accordion class="col-lg-12 ">
        <mat-expansion-panel *ngFor="
        let item of data
          | searchFilter: ['title']:searchText
      " class="margin-bottom-20" (opened)="panelMap[item?.id] = true" (closed)="panelMap[item?.id] = false">
            <mat-expansion-panel-header class="mat-expansion-panel-header--auto">
                <div class="list-item width-stretch">
                    <div class="list-item-content">
                        <div class="heading margin-bottom-10">
                            <h4>{{ item.title }} |&nbsp; </h4>
                            <!-- <span>{{ item.subSectionName }}</span> -->
                        </div>
                      
                    </div>
                    <div class="list-item-action">
                        <ng-template [ngIf]="panelMap[item?.id]">
                            <button mat-icon-button type="button">
                                <img src="assets/images/Edit.png" alt="Edit"
                                    (click)="$event.stopPropagation();editFile(item)">

                            </button>
                            <button mat-icon-button type="button">
                                <img src="assets/images/Delete.png" alt="Delete"
                                    (click)="$event.stopPropagation();deleteFile(item)">
                            </button>
                        </ng-template>

                    </div>
                </div>
            </mat-expansion-panel-header>
            <div class="panel-body content-panel p-4">
                <div class="content-section">
                  <p class="section-title font-weight-bold">Content:</p>
                  <p [innerHTML]="item?.content" class="content-text"></p>
                </div>
                <div class="d-flex flex-row align-items-start mb-4 w-100 justify-content-between">
                    <!-- Image Section -->
                    <div class="image-container mr-4">
                      <p class="section-title font-weight-bold">Thumbanail:</p>
                      <img [src]="item?.imagePath" alt="Team Member" class="teammember-img">
                    </div>
                
                    <!-- Similar Articles Section -->
                    <div class="similar-articles-section" *ngIf="item.similarArticles && item.similarArticles.length>0">
                      <p class="section-title font-weight-bold">Similar Articles:</p>
                      <div *ngFor="let article of item.similarArticles" class="similar-article p-2 mb-2">
                        <p class="article-title text-primary mb-0">{{ article.title }}</p>
                      </div>
                    </div>
                  </div>
              </div>
              
              
              

        </mat-expansion-panel>
    </mat-accordion>
</div>
<div class="col-lg-12 row" *ngIf="selectedSection === 'Infographics'">
    <div class="col-lg-12 ml-2 data-sect">
        <div class="col-lg-12">
            <h3>IAP Page Infographics List</h3>
        </div>

        <table class="table" [svData]="data" #sv="svDataTable" [svRowsOnPage]="pageSize"
            *ngIf="data && data.length > 0">
            <thead>
                <tr>
                    <th class="text-center">Thumbnail FileName</th>
                    <th class="text-center">Image FileName</th>
                    <th class="text-center">Edit</th>
                    <th class="text-center">Delete</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of sv.data">
                    <td placement="top" show-delay="300" class=" text-center hover-container"
                        (click)="viewFile(item.thumbnailPath)">
                        {{ item.thumbnailName
                        }}
                        <img src="assets/icons/view.png" class="view-icon" alt="View Image"
                             *ngIf="item.thumbnailPath">
                    </td>



                    <td placement="top" show-delay="300" class="text-center hover-container"
                        (click)="viewFile(item.filePath)" show-delay="300">
                        {{ item.fileName }}
                        <img src="assets/icons/view.png" class="view-icon" alt="View Image"
                             *ngIf="item.filePath">
                    </td>


                    <!-- <td class="text-center">{{ item.endDate}}</td> -->
                    <td class="text-center">
                        <img src="assets/images/Edit.png" class=" text-center cursor-pointer" (click)="editFile(item)">
                    </td>

                    <td class="text-center">
                        <img src="assets/icons/delete_icon.png" class="text-center cursor-pointer"
                            (click)="deleteFile(item)">
                    </td>
                </tr>
            </tbody>
            <tfoot *ngIf="data?.length > pageSize">
                <tr>
                    <td colspan="5" class="center-paginator">
                        <sv-bootstrap-paginator></sv-bootstrap-paginator>
                    </td>
                </tr>
            </tfoot>
        </table>
        <div *ngIf="data?.length <= 0">
            <p class="no-data">No data found</p>
        </div>

    </div>
</div>

<div class="col-lg-12 row" *ngIf="selectedSection === 'Section1'">
    <div class="col-lg-12 ml-2 data-sect">
      <div class="col-lg-12 text-center mb-4">
        <h3 class="font-weight-bold">IAP Text Details</h3>
      </div>
      <hr />
      <div class="content-section p-4 shadow rounded bg-light">
        <!-- Title and Description -->
        <div class="d-flex justify-content-between align-items-center mb-3" *ngIf="textData">
          <div class="flex-grow-1">
            <h4 class="title text-dark font-weight-bold">
                {{ textData?.title }}
            </h4>
            <p class="description text-muted">
                {{textData?.description}}
            </p>
          </div>
          <div class="d-flex">
            <!-- Edit Button -->
            <button mat-icon-button color="primary" aria-label="Edit Title and Description" class="mr-2" (click)="editFile(textData)" >
              <mat-icon>edit</mat-icon>
            </button>
  
            <!-- Delete Button -->
            <button mat-icon-button color="warn" aria-label="Delete Title and Description" (click)="$event.stopPropagation();deleteFile(textData)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
  
        <!-- No Data Message -->
        <div *ngIf="!textData" class="no-data text-danger mt-3 text-center">No Data Found</div>
      </div>
    </div>
  </div>
    <div class="col-lg-12 row" *ngIf="selectedSection === 'Section2'">
        <div class="col-lg-12 ml-2">
          <div class="col-lg-12 text-center mb-4">
            <h3 class="font-weight-bold">IAP Text Details</h3>
          </div>
          <hr />
      
          <!-- Main Content Section -->
          <div class="row justify-content-center" *ngIf="textData">
            <div class="col-lg-12">
              <div class=" mb-4">
                <div>
                  <!-- Title and Description -->
                  <div class="d-flex justify-content-between align-items-start mb-3">
                    <div>
                      <h4 class=" text-dark font-weight-bold">{{ textData.title }}</h4>
                      <p class=" text-muted">{{ textData.description }}</p>
                    </div>
                    <div>
                      <!-- Action Buttons -->
                       <div class="d-flex">
                      <button mat-icon-button color="primary" aria-label="Edit Title and Description" (click)="editFile(textData)">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button mat-icon-button color="warn" aria-label="Delete Title and Description" (click)="$event.stopPropagation();deleteFile(textData)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                    </div>
                  </div>
      
                  <div class="row">
                    <!-- Information Cards -->
                    <div class="col-md-6 mb-4" *ngFor="let info of textData.subSections">
                      <div class="card h-100 shadow-sm">
                        <div class="card-body">
                          <!-- <h5 class="card-title">{{ info.title }}</h5>
                          <p class="card-text">{{ info.description }}</p> -->
                          <h5 class="card-title">{{info.title}}</h5>
                          <p class="card-text">{{info.description}}</p>
                          <img 
                            [src]="info.iconPath" 
                            alt="{{ info.title }} Icon" 
                            class="img-fluid rounded mt-3 image-width"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
      
              <!-- No Data Message -->
            
            </div>

          </div>
          <div *ngIf="!textData" class="no-data text-danger mt-3 text-center">No Data Found</div>

        </div>
      </div>
      
      <div class="col-lg-12 row" *ngIf="selectedSection === 'Section3'">
        <div class="col-lg-12 ml-2">
          <div class="col-lg-12 text-center mb-4">
            <h3 class="font-weight-bold">IAP Text Details</h3>
          </div>
          <hr />
      
          <!-- Main Content Section -->
          <div class="row justify-content-center">
            <div class="col-lg-12"  *ngIf="textData">
              <div class=" mb-4">
                <div>
                  <!-- Title and Description -->
                  <div class="d-flex justify-content-between align-items-start mb-3">
                    <div>
                      <h4 class=" text-dark font-weight-bold">{{ textData.title }}</h4>
                      <p class=" text-muted">{{ textData.description }}</p>
                    </div>
                    <div>
                      <!-- Action Buttons -->
                      <div class="d-flex">
                      <button mat-icon-button color="primary" aria-label="Edit Title and Description" (click)="editFile(textData)">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button mat-icon-button color="warn" aria-label="Delete Title and Description" (click)="$event.stopPropagation();deleteFile(textData)">
                        <mat-icon>delete</mat-icon>
                      </button>
                      </div>
                    </div>
                  </div>
      
                  <div class="row">
                    <!-- Information Cards -->
                    <div class="col-md-6 mb-4" *ngFor="let info of textData.subSections">
                      <div class="card h-100 shadow-sm">
                        <div class="card-body">
                          <h5 class="card-title">{{ info.title }}</h5>
                          <p class="card-text">{{ info.description }}</p>
                         
                          <img 
                            [src]="info.iconPath" 
                            alt="{{ info.title }} Icon" 
                            class="img-fluid rounded mt-3 image-width"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
      
              <!-- No Data Message -->
           
            </div>
            <div *ngIf="!textData" class=" no-data text-danger mt-3 text-center">
              <h5>No Data Found</h5>
            </div>
          </div>
        </div>
      </div>

      

  <div class="col-lg-12 row" *ngIf="selectedSection === 'Form'">
    <div class="col-lg-12 ml-2 data-sect">
      <div class="col-lg-12 text-center mb-4">
        <h3 class="text-primary font-weight-bold">IAP Text Details</h3>
      </div>
      <hr />
      <div class="content-section p-4 shadow rounded bg-light" *ngIf="textData">
        <!-- Title and Description -->
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div class="flex-grow-1">
            <h4 class="title text-dark font-weight-bold">
                {{ textData?.title }}
            </h4>
            <p class="description text-muted">
                {{ textData?.description }}  
                      </p>
          </div>
          <div class="d-flex">
            <!-- Edit Button -->
            <button mat-icon-button color="primary" aria-label="Edit Title and Description" class="mr-2" (click)="editFile(textData)">
              <mat-icon>edit</mat-icon>
            </button>
  
            <!-- Delete Button -->
            <button mat-icon-button color="warn" aria-label="Delete Title and Description" (click)="$event.stopPropagation();deleteFile(textData)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
  
        <!-- No Data Message -->
        
      </div>
      <div *ngIf="!textData" class="no-data text-danger mt-3 text-center">No Data Found</div>
    </div>
  </div>
  
  <div class="col-lg-12" *ngIf="selectedSection === 'Disclaimer'">
    <div class="col-lg-12 ml-2 data-sect">
      <div class="col-lg-12 text-center mb-4">
        <h3 class="font-weight-bold">IAP Text Details</h3>
      </div>
      <hr />
  
      <div class=" shadow-lg border-0 p-4 bg-white rounded" *ngIf="textData">
        <!-- Header -->
        <div class=" d-flex justify-content-between align-items-center rounded">
          <h4 class="mb-4 font-weight-bold"> {{textData.title}}</h4>
          <div>
            <!-- Edit Button -->
            <div class="d-flex">
            <button mat-icon-button color="accent" aria-label="Edit Title and Description" class="btn btn-light btn-sm mr-2" (click)="editFile(textData)">
              <mat-icon>edit</mat-icon>
            </button>
  
            <!-- Delete Button -->
            <button mat-icon-button color="warn" aria-label="Delete Title and Description" class="btn btn-light btn-sm" (click)="$event.stopPropagation();deleteFile(textData)">
              <mat-icon>delete</mat-icon>
            </button>
            </div>
          </div>
        </div>
  
        <!-- Content -->
       
        <p class="text-muted" [innerHTML]="textData?.description"></p>
       
         
          <div class="mt-3">
            <p class="text-muted font-weight-bold mb-0">Email: {{textData.email}}</p>
            <p class="text-muted font-weight-bold mb-0">Contact: {{textData.mobile}}</p>
            <p class="text-danger mt-2">{{textData.disclaimerAdditionalText}}</p>
          </div>
      </div>
  
      <!-- No Data Message -->
      <div *ngIf="!textData" class="no-data text-danger mt-3 text-center">No Data Found</div>
    </div>
  </div>
  
      